import { useEffect } from "react";
import { getSiteInfoApi } from "@/api/common";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { setSiteInfo } from "@/store/app";

// 进行中的请求，用于多个组件同时挂载时去重，保证同一时刻只发一次 /front/site-info
let inflight: Promise<any> | null = null;
// 发起 inflight 时的登录态：token 变了（免登换票完成）不能复用登录前那次，否则跳转判断拿的是未登录结果
let inflightToken: string | undefined;

/**
 * 获取站点信息（/front/site-info）
 * - 结果缓存在 redux，多个组件共享，避免重复请求
 * - site 变化（切换中国站/国际站）、token 变化（登录/登出）时重新请求，
 *   因为 site-info 的邮寄区域/跳转判断可能随登录状态变化
 */
export function useSiteInfo() {
  const dispatch = useAppDispatch();
  const site = useAppSelector((state) => state.app.site);
  const token = useAppSelector((state) => state.user.token);
  const siteInfo = useAppSelector((state) => state.app.siteInfo);

  useEffect(() => {
    if (!site) return; // site 没有值时不请求
    let cancelled = false;
    const fetchSiteInfo = async () => {
      if (!inflight || inflightToken !== token) {
        inflight = getSiteInfoApi();
        inflightToken = token;
      }
      const mine = inflight;
      try {
        const res: any = await mine;
        if (!cancelled) {
          dispatch(setSiteInfo(res));
        }
      } catch (e) {
        console.error("获取站点信息失败：", e);
      } finally {
        // 只清自己发起的那次，别把 token 变化后新发的请求清掉
        if (inflight === mine) inflight = null;
      }
    };
    fetchSiteInfo();
    return () => {
      cancelled = true;
    };
  }, [site, token, dispatch]);

  return siteInfo;
}
